import axios from "axios";
import { AUTH, SYSTEM_ERROR } from "./CONSTANTS";
import { BASE_URL} from "services/CONSTANTS";

// Add a 401 response interceptor
axios.interceptors.response.use(function (response) {
    return response;
}, function (error) {
    return Promise.reject(error);
});

/**
 * Function to fetch all the users.
 */
export const Get = (request) => {
    const { url, params } = request;
    return new Promise((resolve, reject) => {
        try {
            let encoded = window.btoa(AUTH);

            let config = {
                params,
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Basic " + window.atob(encoded),
                    "Content-Security-Policy": "strict-dynamic",
                    "X-Content-Type-Options": "nosniff"
                }
            };
            axios
                // .get(url, request?.config ? request?.config : config)
                .get(url, config)
                .then((res) => {
                    resolve(res);
                })
                .catch((err) => {
                    reject(err);
                });
        } catch (error) {
            reject(SYSTEM_ERROR);
        }
    });
};

/**
 * Function to post to an api.
 */
export const Post = (request) => {

    const { url, params, config: customConfig } = request;
    return new Promise((resolve, reject) => {
        try {
            let encoded = window.btoa(AUTH);

            let config = {
                headers: {
                    // 'Content-Type': 'application/json;charset=UTF-8',
                    Authorization: "Basic " + window.atob(encoded),
                    "Content-Security-Policy": "strict-dynamic",
                    "X-Content-Type-Options": "nosniff",
                    ...customConfig?.headers
                },


            };
            axios
                // .post(url, params, request.config ? request.config : config)
                .post(url, params, config)
                .then((res) => {
                    resolve(res);
                })
                .catch((errResponse) => {
                    reject(errResponse);
                });
        } catch (error) {
            reject(SYSTEM_ERROR);
        }
    });
};

export const Put = (request) => {

    const { url, params, config: customConfig } = request;
    return new Promise((resolve, reject) => {
        try {
            let encoded = window.btoa(AUTH);

            let config = {
                headers: {
                    // 'Content-Type': 'application/json;charset=UTF-8',
                    Authorization: "Basic " + window.atob(encoded),
                    "Content-Security-Policy": "strict-dynamic",
                    "X-Content-Type-Options": "nosniff",
                    ...customConfig?.headers
                },


            };
            axios
                // .post(url, params, request.config ? request.config : config)
                .put(url, params, config)
                .then((res) => {
                    resolve(res);
                })
                .catch((errResponse) => {
                    reject(errResponse);
                });
        } catch (error) {
            reject(SYSTEM_ERROR);
        }
    });
};

export const PostNew = (apiEndpoint, payload) => {
    return new Promise((resolve, reject) => {
        try {
            let encoded = window.btoa(AUTH);
            return axios
                .post(BASE_URL + apiEndpoint, payload, {

                    headers: {
                        // 'Content-Type': 'application/json;charset=UTF-8',
                        Authorization: "Basic " + window.atob(encoded),
                        "Content-Security-Policy": "strict-dynamic",
                        "X-Content-Type-Options": "nosniff",
                        'Content-Type': 'multipart/form-data',
                    },
                })
              
              .then((res) => {
                    resolve(res);
                })
                .catch((errResponse) => {
                    reject(errResponse);
                });
        } catch (error) {
            reject(SYSTEM_ERROR);
        }
    });
}

export const PostOrderOpp = (apiEndpoint, payload) => {
    return new Promise((resolve, reject) => {
        try {
              let encoded = window.btoa(AUTH);
            return axios
                .post(BASE_URL + apiEndpoint, payload, {
                    headers: {
                         'Content-Type': 'application/json;',
                          Authorization: "Basic " + window.atob(encoded),
                         "Content-Security-Policy": "strict-dynamic",
                         "X-Content-Type-Options": "nosniff",
                       
                    },
                })
              
              .then((res) => {
                    resolve(res);
                })
                .catch((errResponse) => {
                    reject(errResponse);
                });
        } catch (error) {
            reject(SYSTEM_ERROR);
        }
    });
}
export const PostCreate = (apiEndpoint, payload) => {
    return new Promise((resolve, reject) => {
        try {
            let encoded = window.btoa(AUTH);
            return axios
                .post(BASE_URL + apiEndpoint, payload, {
                    headers: {
                         'Content-Type': 'application/json;',
                         Authorization: "Basic " + window.atob(encoded),
                         "Content-Security-Policy": "strict-dynamic",
                          "X-Content-Type-Options": "nosniff",
                       
                    },
                })
              
              .then((res) => {
                    resolve(res);
                })
                .catch((errResponse) => {
                    reject(errResponse);
                });
        } catch (error) {
            reject(SYSTEM_ERROR);
        }
    });
}
export const PostManualUpload = (apiEndpoint, payload) => {
    return new Promise((resolve, reject) => {
        try {
            let encoded = window.btoa(AUTH);
            return axios
                .post(BASE_URL + apiEndpoint, payload, {

                    headers: {
                        Authorization: "Basic " + window.atob(encoded),
                        "Content-Security-Policy": "strict-dynamic",
                        "X-Content-Type-Options": "nosniff",
                        'Content-Type': 'multipart/form-data',
                    },
                })
              
              .then((res) => {
                    resolve(res);
                })
                .catch((errResponse) => {
                    reject(errResponse);
                });
        } catch (error) {
            reject(SYSTEM_ERROR);
        }
    });
}

export const Patch = (request) => {

    const { url, params, config: customConfig } = request;
    return new Promise((resolve, reject) => {
        try {
            let encoded = window.btoa(AUTH);

            let config = {
                headers: {
                    // 'Content-Type': 'application/json;charset=UTF-8',
                    Authorization: "Basic " + window.atob(encoded),
                    "Content-Security-Policy": "strict-dynamic",
                    "X-Content-Type-Options": "nosniff",
                    ...customConfig?.headers
                },


            };
            axios
                .patch(url, params, config)
                .then((res) => {
                    resolve(res);
                })
                .catch((errResponse) => {
                    reject(errResponse);
                });
        } catch (error) {
            reject(SYSTEM_ERROR);
        }
    });
};

export const Delete = (request) => {
    const { url, params } = request;
    return new Promise((resolve, reject) => {
        try {
            let encoded = window.btoa(AUTH);

            let config = {
                params,
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Basic " + window.atob(encoded),
                    "Content-Security-Policy": "strict-dynamic",
                    "X-Content-Type-Options": "nosniff"
                }
            };
            axios
                .delete(url, config)
                .then((res) => {
                    resolve(res);
                })
                .catch((err) => {
                    reject(err);
                });
        } catch (error) {
            reject(SYSTEM_ERROR);
        }
    });
};

export const BulkDeleteMOQ = (request) => {
    const { url, params } = request;
    return new Promise((resolve, reject) => {
        try {
            let encoded = window.btoa(AUTH);

            let config = {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Basic " + window.atob(encoded),
                    "Content-Security-Policy": "strict-dynamic",
                    "X-Content-Type-Options": "nosniff"
                },
                data: params
            };
            axios
                .delete(url, config)
                .then((res) => {
                    resolve(res);
                })
                .catch((err) => {
                    reject(err);
                });
        } catch (error) {
            reject(SYSTEM_ERROR);
        }
    });
};

